import { createContext, useContext, useEffect, useState } from 'react'
import { BREAKPOINTS } from '../lib/stitches'

interface Rectangle {
  width: number
  height: number
}

const ResizeContext = createContext<Rectangle>(null)

export const WindowResizeContextProvider = ResizeContext.Provider

/**
 * Observes changes in window size, specifically listens to resize of the window
 */
export const useWindowResizeObserver = () => {
  const [rectangle, setRectangle] = useState<Rectangle>({
    width: window.innerWidth,
    height: window.innerHeight
  })
  useEffect(() => {
    const handleResize = () => {
      setRectangle({ width: window.innerWidth, height: window.innerHeight })
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  return rectangle
}

/**
 * Consumes window size context and has a bunch of helper functions
 */
export const useWindowSize = () => {
  const { width: screenWidth, height: screenHeight } = useContext(ResizeContext)
  const isBreakpoint = (breakpoint: keyof typeof BREAKPOINTS) =>
    screenWidth >= BREAKPOINTS[breakpoint]
  return { screenWidth, screenHeight, isBreakpoint }
}
